module.exports = __webpack_public_path__ + "img/wcfa-face-border3.b2d7a35e.svg";